<template>
  <div class="map-search">
    <van-search ref="searchRef" id="van-search" class="search-content" :autofocus="true" v-model="searchVal" shape="round" show-action background="#307bff" :placeholder="$t('form.namePostCodeAddressCity')" @input="(val) => handleSearch(val, 'search')" @clear="(val) => handleSearch(val, 'clear')">
      <van-icon slot="left" class="search-left-icon" name="arrow-left" size="23" color="#fff" @click="goBack" />
      <img slot="action" class="right-icon" src="@/assets/images/guolvWhite.png" alt="" @click="handleFilter">
    </van-search>
    <div id="dom-map" class="map-content">
      <div class="header-content">
        <div class="map-status">
          <div class="status-content">
            <div class="status-item" :class="{'status-item-active': mapStatusType === subItem.value}" v-for="(subItem, subIndex) in mapStatusList" :key="subIndex" @click.prevent="handleStatus(subItem)">
              <span>{{ subItem.label }}</span>
              <div class="project-info" v-show="subItem.value === '1' && mapStatusType === '1'" @click.stop>
                <span class="line"></span>
                <van-dropdown-menu active-color="#307bff">
                  <van-dropdown-item v-model="projectId" :options="productList" @open="posIndex = true" @closed="posIndex = false" />
                </van-dropdown-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="storeMap" />
    </div>
    <MapList v-show="mapListShow" ref="mapListRef" :posIndex="posIndex" :mapData="mapData" :currentAddres="currentAddres" :isBottom="true" :pageHeaderH="pageHeaderH" :listRefresh="listRefresh" />
    <MapFilter ref="mapFilterRef" :deptOption="deptOption" @changeFilter="changeFilter" :mapType="mapType" />
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader'
// import { MarkerClusterer, GridAlgorithm } from '@googlemaps/markerclusterer'
import { mapState } from 'vuex'
import MapList from '../StoreMap/components/mapList'
import MapFilter from '../StoreMap/components/mapFilter'
import { arsCustomerAppMapListPageApi, deptTreeDeptApi } from '@/api/home'
import { Toast } from 'vant'
import axios from 'axios'
import loadGoogleMaps from '@/utils/google-maps-loader'

var map
var infoWindow
var geocoder = null
const loader = new Loader({
  apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
  version: 'weekly',
  libraries: ['places', 'drawing'], //插件库
  region: 'US',
  language: 'en'
})
export default {
  name: 'MapSearch',
  components: {
    MapList,
    MapFilter
  },
  data () {
    return {
      searchVal: '', // 搜索
      mapType: '0',
      projectId: '',
      mapStatusType: '1',
      productList: [],
      mapStatusList: [
        { label: 'Store-Tag', value: '0' },
        { label: 'Listed', value: '1' }
      ],
      cancelTokens: [],
      imgUrl: require('@/assets/images/a-dingwei2.png'),
      pinDataUrl: '',
      posIndex: false,
      mapData: [],
      markersArr: [],
      // 视口优化相关变量
      currentViewportBounds: null,
      viewportUpdateTimer: null,
      conditionForm: {
        // 基本信息
        search: '', // 搜索
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: []
      },
      paginationList: {
        page: 1,
        limit: 100,
        total: 0
      },
      changeLatLng: {},
      isSearchOnce: false,
      mapZoom: 12,
      deptOption: [],
      currentAddres: '',
      pageHeaderH: 0,
      mapListShow: false,
      listRefresh: false,
      map: null
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    })
  },
  created () {
    this.globalData.productList.forEach((subItem) => {
      this.productList.push({ text: subItem.productName, value: subItem.id })
    })
    this.projectId = this.productList[0].value
    this.searchVal = ''
    this.currentAddres = ''
    this.getMyVisit()
  },
  async mounted () {
    this.$nextTick(() => {
      // this.$refs.searchRef.focus()
      this.$el.querySelector('.van-field__control').focus()
      // this.$refs.searchRef.querySelector('input').focus()
      // geocoder = new google.maps.Geocoder()
      // this.initMap()
    })
    const viewHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    this.pageHeaderH = document.getElementById('van-search').offsetHeight
    const mapDom = document.getElementById('storeMap')
    mapDom.style.height = `${viewHeight - this.pageHeaderH}px`
    const maps = await loadGoogleMaps() // 不传参数也会复用之前的
    geocoder = new maps.Geocoder()
    this.initMap()
  },
  activated () {
    // 重新初始化地图和标记
    if (this.map && this.mapData.length > 0) {
      // 重新绘制所有标记
      this.drawMap(this.mapData)
      // 重新优化标记显示
      this.optimizeMarkerDisplay()
    }
  },
  deactivated () {
    // this.$destroy()
    // 取消所有未完成请求
    this.cancelTokens.forEach((cancel) => cancel('组件销毁，取消请求'))
    this.cancelTokens = []
    // 清理视口优化相关的定时器
    if (this.viewportUpdateTimer) {
      clearTimeout(this.viewportUpdateTimer)
      this.viewportUpdateTimer = null
    }

    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    handleSearch (val, type) {
      if (this.searchVal === '') {
        this.dataReset()
        this.markersArr = []
        this.isSearchOnce = true
        this.changeLatLng = { lat: '', lng: '' }
      }
      if (type === 'search' && this.searchVal !== '') {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          clearTimeout(this.timer)
          // this.listRefresh = true
          this.changeFilter()
        }, 800)
      } else {
        this.$nextTick(() => {
          // this.$refs.searchRef.focus()
          this.$el.querySelector('.van-field__control').focus()
        })
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    dataReset () {
      this.cancelTokens.forEach((cancel) => cancel('组件销毁，取消请求'))
      this.cancelTokens = []
      for (let i = 0; i < this.markersArr.length; i++) {
        this.markersArr[i].marker.setMap(null)
      }
      this.markersArr = []
      this.mapData = []
      this.paginationList.page = 1
    },
    // 状态修改
    handleStatus (params) {
      if (params.value === '1') {
        this.productId = this.productList[0].value
      } else {
        this.productId = ''
      }
      this.mapStatusType = params.value
      this.dataReset()
      this.getListData()
    },
    getListData () {
      const {
        personVal,
        userIdList,
        sortField
      } = this.conditionForm
      const data = {
        ...this.paginationList,
        ...this.conditionForm,
        userIdList: personVal.includes('Me')
          ? [...userIdList, this.userInfo.user.id]
          : userIdList,
        sortField: sortField ? sortField.split('-')[0] : '',
        order: sortField ? sortField.split('-')[1] : '',
        limit: this.isSearchOnce ? 1 : 100,
        ...this.changeLatLng,
        search: this.searchVal,
        productId: this.productId,
        distance: this.isSearchOnce ? '' : (17 - this.mapZoom) * 50 * 1000 // 250000
      }
      const source = axios.CancelToken.source()
      this.cancelTokens.push(source.cancel)
      if (this.paginationList.page === 1) {
        this.listRefresh = true
      }
      arsCustomerAppMapListPageApi(data, source.token)
        .then((res) => {
          if (!this.mapListShow) {
            this.mapListShow = true
          }
          if (this.paginationList.page === 1) {
            this.mapData = []
          }
          this.paginationList.total = Number(res.data.totalRow)
          const newMapData = [...this.mapData]
          res.data.list.forEach((subItem) => {
            subItem.centerDistance = this.calculateDistance(
              this.changeLatLng.lat,
              this.changeLatLng.lng,
              subItem.lat,
              subItem.lng
            )
            const exists = newMapData.map((existingItem) => existingItem.id)
            if (!exists.includes(subItem.id)) {
              newMapData.push(subItem)
            }
          })
          newMapData.sort((a, b) => a.centerDistance - b.centerDistance)
          this.mapData = JSON.parse(JSON.stringify(newMapData))
          // 把新数组 与 原来的 数组 进行 合并
          // this.mapData = [...this.mapData, ...res.data.list]
          this.drawMap(res.data.list)
          this.listRefresh = false
        })
        .catch(() => {})
        .finally(() => {
          // 移除已完成的取消函数
          const index = this.cancelTokens.indexOf(source.cancel)
          if (index !== -1) this.cancelTokens.splice(index, 1)
        })
    },
    // 地图初始化
    initMap (arr) {
      const currentTimeLoc = JSON.parse(
        window.localStorage.getItem('currentTimeLoc')
      )
      if (currentTimeLoc) {
        this.getInitMap(currentTimeLoc)
      } else {
        // 三星手机不能频繁获取当前定位
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const newTimeLoc = {
              time: Date.now(),
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            window.localStorage.setItem(
              'currentTimeLoc',
              JSON.stringify(newTimeLoc)
            )
            this.getInitMap(newTimeLoc)
          },
          () => {
            handleLocationError(true, infoWindow, this.map.getCenter())
          }
        )
      }
    },
    getInitMap (position) {
      loader.load().then(async () => {
        const { Map, InfoWindow } = await google.maps.importLibrary('maps')
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
          'marker'
        )
        let centerLatLng = {
          lat: position.lat,
          lng: position.lng
        }
        if (process.env.NODE_ENV === 'development') {
          centerLatLng = {
            lat: 47.53441369999999, // 47.23396409999999, // 48.3040337, // 35.0504977,
            lng: -122.6278949 // -122.6436691 // -89.8394555
          }
        }
        this.currentLatLng = centerLatLng
        this.changeLatLng = centerLatLng
        infoWindow = new google.maps.InfoWindow()
        const styledMapType = new google.maps.StyledMapType(
          [
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi.business',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'road.local',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            }
          ],
          { name: 'Styled Map' }
        )
        this.map = new Map(document.getElementById('storeMap'), {
          center: centerLatLng,
          // center: { lat: 35.0504977 || parseFloat(arr[0].lat) || 22.5580928, lng: -89.8394555 || parseFloat(arr[0].lng) || 113.9417393 },
          // zoom: 2, // 14,
          zoom: 12,
          minZoom: 8,
          maxZoom: 16,
          gestureHandling: 'greedy',
          mapId: 'DEMO_MAP_ID',
          streetViewControl: false, // 隐藏街景小人
          mapTypeControl: false,
          fullscreenControl: false
        })
        // this.markerClusterer = new MarkerClusterer({ map, algorithm: new GridAlgorithm({gridsize: 30, maxDistance: 60000})})
        // this.markerClusterer = new MarkerClusterer({ map })
        this.map.mapTypes.set('styled_map', styledMapType)
        this.map.setMapTypeId('styled_map')
        // this.getlocation(centerLatLng.lat, centerLatLng.lng)
        // this.resetPage()
        // this.getMapData()

        this.map.addListener('dragend', () => {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
            // this.getlocation(map.getCenter().lat(), map.getCenter().lng())1111
            this.changeLatLng = {
              lat: this.map.getCenter().lat(),
              lng: this.map.getCenter().lng()
            }
            this.cancelTokens.forEach((cancel) => cancel('组件销毁，取消请求'))
            this.cancelTokens = []
            this.paginationList.page = 1
            this.updateViewportBounds()
            // 立即优化当前标记显示
            this.optimizeMarkerDisplay()
            this.getListData()
          }, 1500)
        })
        this.map.addListener('dragstart', () => {
          this.$refs.mapListRef.currentStateIndex = 0
          this.$refs.mapListRef.calculatePanelHeight()
        })
        this.map.addListener('zoom_changed', () => {
          // 在这里添加你的代码，当地图的缩放级别发生改变时执行
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
            this.mapZoom = this.map.getZoom()
            this.paginationList.page = 1
            this.cancelTokens.forEach((cancel) => cancel('组件销毁，取消请求'))
            this.cancelTokens = []
            this.updateViewportBounds()
            // 立即优化当前标记显示
            this.optimizeMarkerDisplay()
            this.getListData()
          }, 2000)
        })

        // 回到中心点
        const centerControlDiv = document.createElement('div')
        centerControlDiv.style.padding = '5px'
        centerControlDiv.style.borderRadius = '3px'
        centerControlDiv.style.backgroundColor = '#fff'
        centerControlDiv.style.margin = '70px 0px 10px 10px'
        centerControlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
        const centerControl = this.createCenterControl(
          this.map,
          centerLatLng,
          'center'
        )
        centerControlDiv.appendChild(centerControl)
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(
          centerControlDiv
        )

        const parser = new DOMParser()
        const markerSvg =
          '<svg class="icon" width="18px" height="18.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 512m-486.61240522 0a486.61240522 486.61240522 0 1 0 973.22481044 0 486.61240522 486.61240522 0 1 0-973.22481044 0Z" fill="#d3e8ff" /><path d="M512 512m-272.22290474 0a272.22290474 272.22290474 0 1 0 544.44580948 0 272.22290474 272.22290474 0 1 0-544.44580948 0Z" fill="#0034a2" /></svg>'
        this.pinDataUrl = parser.parseFromString(
          markerSvg,
          'image/svg+xml'
        ).documentElement
        this.currentMarker = new AdvancedMarkerElement({
          map: this.map,
          position: centerLatLng,
          content: this.pinDataUrl,
          zIndex: google.maps.Marker.MAX_ZINDEX + 1
        })
        // this.getListData()
      })
    },
    async drawMap (newArr) {
      const { AdvancedMarkerElement, PinElement } =
        await google.maps.importLibrary('marker')
      // 更新视口边界
      this.updateViewportBounds()
      newArr.forEach((item, index) => {
        const exists = this.markersArr.some(
          (existingItem) => existingItem.customerId === item.id
        )
        if (item.lat && !exists) {
          // let parser = new DOMParser()
          // '#0000f5' : '#ec8300'
          let typeColor = ''
          if (this.mapStatusType === '0') {
            typeColor = [1, '1'].includes(item.customerTag) ? '#d45648' : [2, '2'].includes(item.customerTag) ? '#1f9d16' : [3, '3'].includes(item.customerTag) ? '#898989' : '#307bff'
          } else if (this.mapStatusType === '1') {
            typeColor = item.isExist > 0 ? '#0000ff' : '#808080'
          } else {
            typeColor = '#307bff'
          }
          const newApartLastVisitDay = item.visitDifferDay
            ? item.visitDifferDay
            : ''
          const pinBackground = new PinElement({
            background: typeColor,
            borderColor: typeColor,
            glyphColor: 'white',
            glyph:
              newApartLastVisitDay && newApartLastVisitDay > 99
                ? '99+'
                : newApartLastVisitDay
          })
          const marker = new AdvancedMarkerElement({
            map: this.map,
            position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
            content: pinBackground.element,
            gmpClickable: true,
            title: `${item.id}`
          })
          marker.addListener('click', () => {
            this.$refs.mapListRef.handleListItem({
              type: 'details',
              data: item
            })
          })
          // 检查标记是否在视口内，控制显示/隐藏
          const isInViewport = this.isMarkerInViewport(item)
          marker.setMap(isInViewport ? this.map : null)
          this.markersArr.push({ title: item.id, marker, customerId: item.id })
        }
      })
      // 把 loading 设置为false，表示 可以进行 下一次请求了
      if (
        newArr.length > 0 &&
        (this.mapData.length < this.paginationList.total || this.isSearchOnce)
      ) {
        if (this.isSearchOnce) {
          this.isSearchOnce = false
          this.changeLatLng = {
            lat: parseFloat(newArr[0].lat),
            lng: parseFloat(newArr[0].lng)
          }
          this.map.setCenter(this.changeLatLng)
          // this.getlocation(this.changeLatLng)
          this.paginationList.page = 1
        } else {
          this.paginationList.page++
        }
        this.getListData()
      } else {
        this.isSearchOnce = false
        // 所有数据加载完成后，优化标记显示
        this.optimizeMarkerDisplay()
      }
    },
    createCenterControl (map, centerLatLng, iconType) {
      const controlButton = document.createElement('img')
      // Set CSS for the control.
      controlButton.style.cursor = 'pointer'
      controlButton.title = 'Click to recenter the map'
      if (iconType === 'center') {
        controlButton.src = this.imgUrl
        controlButton.addEventListener('click', () => {
          // map.setCenter(centerLatLng)
          // this.listRefresh = true
          this.dataReset()
          this.getCurrentLoc(map)
        })
      }
      // Setup the click event listeners: simply set the map to Chicago.
      return controlButton
    },
    // 获取当前位置
    getCurrentLoc (map) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
          )
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          window.localStorage.setItem(
            'currentTimeLoc',
            JSON.stringify({ ...pos, time: Date.now() })
          )
          this.currentLatLng = pos
          this.changeLatLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.getListData()
          // this.getVisitPlanDetail()
          this.getlocation(pos.lat, pos.lng)
          this.currentMarker.setMap(null)
          map.setCenter(pos)
          // this.currentMarker = new google.maps.Marker({
          //   position: this.currentLatLng,
          //   clickable: true,
          //   icon: this.pinDataUrl,
          //   zIndex: google.maps.Marker.MAX_ZINDEX + 199, // google.maps.Marker.MAX_ZINDEX + 1,
          //   map: map
          // })
          this.currentMarker = new AdvancedMarkerElement({
            map,
            position: this.currentLatLng,
            content: this.pinDataUrl,
            zIndex: google.maps.Marker.MAX_ZINDEX + 1
          })
        },
        () => {
          handleLocationError(true, infoWindow, map.getCenter())
        }
      )
    },
    handleFilter () {
      this.$refs.mapFilterRef.filterShow = true
    },
    getMyVisit () {
      deptTreeDeptApi().then((res) => {
        this.deptOption = this.stripInPlace(res.data)
      })
    },
    stripInPlace (list) {
      list.forEach((node) => {
        if (Array.isArray(node.children)) {
          if (node.children.length) {
            this.stripInPlace(node.children)
          } else {
            delete node.children
          }
        }
      })
      return list
    },
    changeFilter (data) {
      if (data) {
        this.conditionForm = data
      }
      this.dataReset()
      // this.markersArr = []
      this.isSearchOnce = true
      this.changeLatLng = { lat: '', lng: '' }
      this.getListData()
    },
    getlocation (lat, lng) {
      const $that = this
      // 根据经纬度获取位置
      geocoder.geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            // console.log('地理反解析结果：' + );
            // results[0].formatted_address
            // results[0].geometry.location
            // centerPoint.address = results[0].formatted_address
            // centerPoint.results = results
            // map.setCenter(centerPoint)
            // document.getElementById('postMessage').click()
            $that.currentAddres = results[0].formatted_address.split(',')[0]
            $that.$refs.mapListRef.cureentPos =
              results[0].formatted_address.split(',')[0]
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    // 两个经纬度之间的距离
    calculateDistance (lat = '', lng = '', myLat = '', myLng = '') {
      const centerLat = lat
      const centerLng = lng

      const red1 = (myLat * Math.PI) / 180.0
      const red2 = (centerLat * Math.PI) / 180.0
      const a = red1 - red2
      const b = (myLng * Math.PI) / 180.0 - (centerLng * Math.PI) / 180.0
      const R = 6378137
      const distance =
        R *
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(red1) * Math.cos(red2) * Math.pow(Math.sin(b / 2), 2)
          )
        )
      const res = (distance / 1000).toFixed(2) * 1

      return res
    },
    // 更新视口边界
    updateViewportBounds () {
      if (this.map) {
        this.currentViewportBounds = this.map.getBounds()
      }
    },
    // 判断标记是否在当前视口内
    isMarkerInViewport (item) {
      if (!this.currentViewportBounds || !item.lat || !item.lng) {
        return true // 如果没有视口信息，默认显示
      }

      const markerLatLng = new google.maps.LatLng(
        parseFloat(item.lat),
        parseFloat(item.lng)
      )
      return this.currentViewportBounds.contains(markerLatLng)
    },
    // 优化标记显示
    optimizeMarkerDisplay () {
      if (this.viewportUpdateTimer) {
        clearTimeout(this.viewportUpdateTimer)
      }

      this.viewportUpdateTimer = setTimeout(() => {
        this.updateViewportBounds()

        // 隐藏视口外的标记
        this.markersArr.forEach((markerObj) => {
          const markerData = this.mapData.find(
            (item) => item.id === markerObj.customerId
          )
          if (markerData) {
            const isVisible = this.isMarkerInViewport(markerData)
            markerObj.marker.setMap(isVisible ? this.map : null)
          }
        })
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.map-search {
  overflow: hidden;
  .search-content {
    padding: 8px 10px;
    /deep/.van-cell {
      line-height: 20px;
    }
    /deep/.van-search__action {
      display: flex;
      align-items: center;
    }
  }
  .search-left-icon {
    margin-right: 10px;
  }
  .right-icon {
    width: 20px;
    height: 20px;
  }
  .map-content {
    position: relative;
    font-size: 12px;
    #storeMap {
      // border: 1px solid #000;
    }
    .header-content {
      width: 100%;
      position: absolute;
      z-index: 96;
      padding-top: 10px;
      .search-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 10px;
      }
      .search-content {
        display: flex;
        align-items: center;
        flex: 1;
        height: 33px;
        margin-right: 10px;
        line-height: 33px;
        border-radius: 20px;
        border: 1px solid gray;
        background-color: #f7f8fa;
        .left-info {
          display: flex;
          align-items: center;
          padding: 0 0px 0 15px;
          min-width: 62px;
          > img {
            width: 16px;
            height: 16px;
          }
        }
        .line {
          width: 1px;
          height: 10px;
          margin: 0 10px 0 0px;
          background: #afaba8;
        }
        .right-info {
          display: flex;
          align-items: center;
          color: gray;
          .search-icon {
            margin-right: 5px;
          }
        }
      }
      .status-content {
        display: flex;
        align-items: center;
        padding: 0px 10px;
        .status-item {
          height: 30px;
          line-height: 30px;
          padding: 0 5px;
          background-color: #bababa;
          color: #000;
          margin-right: 5px;

          display: flex;
          align-items: center;
          .project-info {
            display: flex;
            align-items: center;
            .line {
              width: 1px;
              height: 16px;
              margin: 0 5px;
              background: #fff;
            }
            /deep/.van-ellipsis {
              font-size: 12px;
            }
          }
          /deep/.van-dropdown-menu__bar {
            height: auto;
            font-size: 12px;
            background-color: transparent;
          }
          /deep/.van-dropdown-menu__title {
            padding-left: 0;
          }
          /deep/.van-dropdown-item__content {
            min-width: 166px;
            max-width: 206px;
            left: 123px;
            .van-dropdown-item__option {
              padding: 10px;
              .van-cell__title {
                font-size: 12px;
              }
              .van-cell__value {
                flex: none;
                width: 20px;
              }
            }
          }
          &:nth-child(2) {
            padding: 0 10px;
          }
          &:last-child {
            margin-right: 0px;
          }
        }
        .status-item-active {
          color: #fff;
          background-color: #307bff;
          /deep/.van-dropdown-menu__title {
            color: #fff !important;
            &::after {
              border-color: transparent transparent #fff #fff;
            }
          }
        }
      }
      .filter-img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>